var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPinkSpring = function SvgPinkSpring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 551,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.781 16.818C5.228 23.916-38.009 237.009 95.003 280.288c133.012 43.28 31.236-225.908-52.687-19.857-53.274 130.797 285.293 96.209 318.252 273.217",
    stroke: "#F05",
    strokeWidth: 33,
    strokeLinecap: "round"
  })));
};
export default SvgPinkSpring;